import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const register = () => {
    history.push("/register", { from: "Header" });
  };

  const login = () => {
    history.push("/login", { from: "Header" });
  };

  const logOut = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("balance");
    enqueueSnackbar("Logged out", {
      variant: "success",
    });
    history.push("/");
    window.location.reload();
  };

  const backToexplore = (
    <Button
      className="explore-button"
      startIcon={<ArrowBackIcon />}
      variant="text"
      onClick={() => history.push("/", { from: "Header" })}
    >
      Back to explore
    </Button>
  );

  const login_Register_btn = (
    <Stack spacing={2} direction="row" key="logout">
      <Button variant="text" onClick={login}>
        LOGIN
      </Button>
      <Button variant="contained" onClick={register}>
        REGISTER
      </Button>
    </Stack>
  );

  const Avatar_logout_btn = (
    <Stack
      spacing={2}
      justifyContent="center"
      alignItems="center"
      direction="row"
      key="login"
    >
      <Avatar alt="crio.do" src="avatar.png" />
      <b>{localStorage.getItem("username")}</b>
      <Button variant="text" onClick={logOut}>
        LOGOUT
      </Button>
    </Stack>
  );

  let checkbutton = localStorage.getItem("username")
    ? [children, Avatar_logout_btn]
    : [children, login_Register_btn];

  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
      {hasHiddenAuthButtons ? checkbutton : backToexplore}
    </Box>
  );
};

export default Header;
